import { analytics } from '../../firebase';
import { setUserId as fbSetUserId } from 'firebase/analytics';

export default function setUserId(id: string | null) {
    return fbSetUserId(analytics, id);
}
